// Страница «Реквизиты и контакты», /requisites.
export default `# Реквизиты и контакты

{{fullName}}

Сокращённое наименование: {{shortName}}

ИНН / КПП: {{inn}} / {{kpp}}

ОГРН: {{ogrn}}

Место нахождения: Российская Федерация, город Москва

Адрес: {{address}}

Контактный email: {{contactEmail}}

По вопросам персональных данных: {{privacyEmail}}
`;
